import src from "IMAGE";
export default { src, width: 40, height: 29, blurWidth: 0, blurHeight: 0};
